module.exports = __webpack_public_path__ + "img/gal_10.37a8ffd0.png";